import Events from '@utilities/events';
import { html } from '@utilities/dom-elements';
import { addBodyLock, removeBodyLock } from '@utilities/lock-body';

import '@utilities/focus-trap';

const CLASS_NAVIGATION_OPEN = 'is--mobile-navigation-open';
const CLASS_NO_SCROLL = 'no--scroll';

class MobileNavigation {
  constructor(element) {
    this.element = element;

    this.bindEvents();
  }

  bindEvents() {
    Events.$on('toggle[mobile-navigation]::toggled', (_, isActive) => {
      if (isActive) {
        setTimeout(() => {
          this.element.classList.add(CLASS_NAVIGATION_OPEN);
        }, 0);

        addBodyLock();
        html.classList.add(CLASS_NO_SCROLL);

        Events.$trigger('header::show');
        Events.$trigger('focustrap::activate', {
          data: {
            element: this.element,
            autoFocus: true,
          },
        });
      } else {
        removeBodyLock();
        html.classList.remove(CLASS_NO_SCROLL);
        this.element.classList.remove(CLASS_NAVIGATION_OPEN);

        Events.$trigger('focustrap::deactivate');
        Events.$trigger(`pagedNavigation[mobile-navigation]::changeView`, {
          data: {
            viewID: 'mobile-navigation-landing',
            animate: false
          }
        });
      }
    });
  }
}

export default MobileNavigation;
